/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PutLoadCarrierRequest } from '../../models/put-load-carrier-request';

export interface PutLoadCarrier$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note bundle key
 */
  deliveryNoteBundleKey: KeyType;

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;
      body: PutLoadCarrierRequest
}

export function putLoadCarrier(http: HttpClient, rootUrl: string, params: PutLoadCarrier$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putLoadCarrier.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteBundleKey', params.deliveryNoteBundleKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putLoadCarrier.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles/{deliveryNoteBundleKey}/delivery-notes/{deliveryNoteKey}/load-carriers';
